import { render, staticRenderFns } from "./goodsInHisList.vue?vue&type=template&id=15dbc1cd&scoped=true"
import script from "./goodsInHisList.vue?vue&type=script&lang=js"
export * from "./goodsInHisList.vue?vue&type=script&lang=js"
import style0 from "./goodsInHisList.vue?vue&type=style&index=0&id=15dbc1cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dbc1cd",
  null
  
)

export default component.exports